<section id="main">
    <div class="mtn-title">
        <p>{{ this.moduleName }}</p>
    </div>
    <div class="form-btns">
        <a (click)="onButtonClick()" class="btn btn2">Click here to redirect</a>
    </div>
</section>
